import axios from 'axios'

import isHttpError from './helper-http-error'

import { settings } from '../../main/configs/settings'

import IAdress from '../interfaces/adress'

export class GeodecoderHelper {
  static apiKey = settings.GOOGLE_API_KEY

  httpClient: any

  static async geocodeAddress(address: IAdress) {
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      this.addressToString(address),
    )}&key=${this.apiKey}`

    try {
      const response = await axios.get(apiUrl)

      const { location } = response.data.results[0].geometry
      const { lat, lng } = location
      return { lat, lng }
    } catch (error) {
      const httpError = isHttpError(error)

      if (httpError) {
        throw httpError
      }
    }

    return null
  }

  static addressToString(address: IAdress) {
    const {
      street, complement, neighborhood, city, state,
    } = address

    const components = [street, complement, neighborhood, city, state].filter(
      Boolean,
    )

    return components.join(', ')
  }
}
